import { observable, makeObservable } from 'mobx'
import queryString from 'query-string'
import i18n from 'i18next'
import * as R from 'ramda'
import { hotjar } from 'react-hotjar'

import Survey from './Survey'
import Question from './Question'
import Page from './Page'
import Http from './utils/Http'
import UserData from './Models/UserData'
import { getProductMap } from './utils/helpers'

const COLLAPSED_SSM_KEY = 'collapsedSSM'

export class AppState {
    @observable shouldShow = true

    @observable userData = {}

    @observable showAdminBox = false

    @observable i18nLoaded = false

    @observable showUserDropdown = false

    @observable isLoginChoose = true

    @observable isEditClientOpen = false // for ClientEdit modal

    @observable showMissingInheritedQuestionModal = false

    @observable numberOfLoggedinUsers = 0

    missingInheritedQuestionModalData = null

    client = {
        industries: [],
        respondentTypes: [],
        surveyTypes: [],
    }

    _notificationSystem = null

    // dragLayer = new DragLayer();
    data = {}

    queryParams = {}

    @observable langcode = R.pathOr(undefined, ['locale'], this.userData) // getUserLang()

    reloadPage = false

    @observable timeZone = R.pathOr(undefined, ['timezone'], this.userData) // getUserTZ()

    host = ''

    builderOffset = 0

    question_types = [
        { value: 'RD', label: 'Single Choice' },
        { value: 'CH', label: 'Multi Choice' },
        { value: 'TX', label: 'Text box' },
        { value: 'TA', label: 'Text area' },
        { value: 'TB', label: 'Grid' },
        { value: 'SG', label: 'SmartGrid' },
        { value: 'OD', label: 'Priority' },
        { value: 'PC', label: 'Percent' },
        { value: 'I', label: 'Number range' },
        { value: 'RT', label: 'Ratings' },
        { value: 'CO', label: 'Country list' },
        { value: 'ST', label: 'Static text' },
        { value: 'SB', label: 'Drop-down list' },
        { value: 'UV', label: 'URL Variable' },
        { value: 'TL', label: 'Text box list' },
        // { value: 'FM', label: 'Form' },
        { value: 'DT', label: 'Date' },
    ]

    @observable questions = []

    @observable breadcrumps = []

    questionPipeSettings = {
        options: [],
    }

    @observable surveyLocale = undefined

    @observable failedToLoadSurvey = false

    @observable questionDeleteConfirm = false

    @observable pageHideConfirm = false

    @observable pageBlockHideConfirm = false

    @observable pageBlockDeleteConfirm = false

    @observable pageDeleteConfirm = false

    @observable showQuestionEditor = false

    @observable showQuestionPipe = false

    @observable surveyCloseConfirm = false

    @observable surveyDeleteConfirm = false

    @observable skiplogicDiscardConfirm = false

    @observable mandatoryQuestion = false

    @observable missingSmartOptions = false

    @observable num_questions = 0

    @observable question = observable.map({})

    @observable colorSettings = observable.map({})

    @observable infoAccordion = observable.map({
        surveyStyling: true,
    })

    @observable tabIndex = 0

    @observable showIds = false

    @observable mode = 'loading'

    @observable loading = false

    @observable survey = ''

    @observable tokenData = null

    @observable csvDownload = false

    @observable hascampaign = false

    @observable hasOnSite = false

    @observable hasIntercept = false

    @observable hasEmbed = false

    @observable hasQR = false

    @observable useLatestUI = true

    @observable questionDisableConfirm = false

    @observable aiQuestions = {
        addModalOpen: false,
        removeModalOpen: false,
        add: () => {},
        remove: () => {},
    }

    @observable loginRedirect = ''

    /** tmp */
    @observable surveyQR = false

    @observable surveyIntercept = false

    @observable surveyEmbed = false

    /** end tmp */
    max_page = 0

    @observable notificationRead = false

    @observable showSurveys = false

    productLocales = {}

    @observable showExplori = false

    @observable showClientTemplates = false

    @observable showScratch = false

    @observable hasUnsavedSkipLogic = false

    @observable showUnsavedSkipLogicModal = false

    @observable countries = []

    @observable focusProduct = false

    @observable preview = '<h2>Preview</h2>'

    skipToPageTarget = {}

    @observable surveyCloneConfirm = false

    @observable showInheritanceWarning = false

    @observable exploriLiteEditWarning = { show: false, questionLevel: undefined }

    @observable pendingExploriEdit = null

    @observable defaultYrOnYrSurveyId

    productIsOnsite = false

    @observable skipLogicConfig = {}

    userData = {}

    mandatoryQuestions = []

    emailAllowance = {}

    /**
     * Survey fields
     */
    test = observable.map({})

    @observable downloadModalOpen = false

    @observable showPageRouting = false

    @observable showChartCreation = false

    @observable chartCreationPageId = null

    @observable showTemplateCreation= false

    @observable templateCreationPageId = null

    @observable showSkipLogic = false

    @observable lang

    @observable pages = []

    @observable picture

    @observable tokenLoaded = false

    @observable surveyLanguages = []

    @observable loggedIn = false

    @observable hasValidSession = false

    surveyMappedQuestionIds = new Map()

    surveyAiQuestionMapping = new Map()

    languages = [{ value: 'az_AZ', label: 'Azerbaijani' }, { value: 'de_DE', label: 'German' }, { value: 'en_GB', label: 'English (UK)' }, { value: 'en_US', label: 'English (US)' }, { value: 'es_ES', label: 'Spanish' }, { value: 'fr_FR', label: 'French' }, { value: 'it_IT', label: 'Italian' }, { value: 'ko_KR', label: 'Korean' }, { value: 'nl_NL', label: 'Dutch' }, { value: 'pt_BR', label: 'Portuguese (Brazilian)' }, { value: 'ru_RU', label: 'Russian' }, { value: 'tr_TR', label: 'Turkish' }, { value: 'zh_CN', label: 'Simplified Chinese' }, { value: 'cy', label: 'Welsh' }, { value: 'zh_TW', label: 'Traditional Chinese' }]

    urlSearch = queryString.parse(window.location.search)

    mergeFields = []

    @observable iframeRefs = new Map()

    modalConfig = {}

    @observable modals = new Map([
        ['pageSkipLogicPreview', false],
    ])

    // V2: SKIP LOGIC
    @observable skipLogicModalVisible = false

    @observable skipLogicModalData = {
        page: null,
        pageId: null,
    }

    @observable serviceStatus = {
        id: undefined,
        status: '',
        style: '', // old param
        collapsible: false,
        textColor: '',
        bgColor: '',
    }

    @observable showDebug = false

    @observable showTranslate = false

    @observable isTemplatePublished = false

    @observable isProductSalesIntelligenceEnabled = false

    @observable isTemplate = false

    previousSkipLogic

    benchmarkPeriods = [
        {
            period: {
                periodType: 'ROL',
                duration: 36,
            },
            value: 36,
            label: '36 months',
        },
        {
            period: {
                periodType: 'ROL',
                duration: 84,
            },
            value: 84,
            label: 'Long term',
        },
    ]

    toggleDebug = (e) => {
        e.stopPropagation()
        this.showDebug = !this.showDebug
    }

    showModal = (modal, config) => {
        if (!this.modals.has(modal)) {
            console.error('toggleModal', `No modal found with key ${modal}`)
            return
        }

        this.modalConfig = config
        this.modals.set(modal, true)
    }

    hideModal = (modal) => {
        if (!this.modals.has(modal)) {
            console.error('toggleModal', `No modal found with key ${modal}`)
            return
        }

        this.modalConfig = {}
        this.modals.set(modal, false)
    }

    addDropContext = (i, t) => {
        this.dropTargets[i] = t
    }

    toggleInfoAccordion = (key, value) => {
        if (!R.isNil(value)) {
            this.infoAccordion.set(key, value)
        } else {
            this.infoAccordion.set(key, !this.infoAccordion.get(key))
        }
    }

    resetResetErrors = () => {
        this.expiredResetLink = false
        this.invalidResetLink = false
        this.usedResetLink = false
    }

    handleUnsavedSkipLogicChanges = () => {
        if (this.hasUnsavedSkipLogic) return

        this.hasUnsavedSkipLogic = true
    }

    handleSaveSkipLogicChanges = () => {
        this.hasUnsavedSkipLogic = false
    }

    openUnsavedSkipLogicModal = () => {
        this.showUnsavedSkipLogicModal = true
    }

    closeUnsavedSkipLogicModal = () => {
        this.showUnsavedSkipLogicModal = false
    }

    dropTargets = {}
    // @observable editable_question = new Question()
    /** end survey fields */

    getCookie = (name) => {
        const cookieString = decodeURIComponent(document.cookie)
        const cookies = cookieString.split(';').map((c) => c.trim().split('='))

        const wantedCookie = cookies.find(([k]) => k === name)
        return (wantedCookie)
            ? wantedCookie[1]
            : undefined
    }

    constructor() {
        makeObservable(this)
        this.survey = new Survey(this)
        this.csrf = this.getCookie('csrf')
        this.mergeFields = [
            {
                code: 'eventdates',
                title: i18n.t('merge_field_eventdates'),
            },
            {
                code: 'eventyear',
                title: i18n.t('merge_field_eventyear'),
            },
            {
                code: 'surveytitle',
                title: i18n.t('merge_field_surveytitle'),
            },
            {
                code: 'productname',
                title: i18n.t('merge_field_productname'),
            },
        ]
    }

    resetLicenceAllowance = () => {
        this.emailAllowance = {
            limit: 0,
            send: 0,
            left: 0,
            clientOnlyEmailServers: false,
            isGeSurveyEmailEnabled: false,
            isGeLimitExempt: false,
        }
    }

    showLoading = () => (
        this.loading
    )

    isMasterSuper = () => {
        const { role } = this.userData
        return role <= 110
    }

    isExploriAdmin = () => {
        const { isAdmin } = this.userData
        return isAdmin
    }

    isExploriStaff = () => {
        const { flags: { isExploriStaff } } = this.userData
        return isExploriStaff
    }

    isSuperUser = () => {
        const { role } = this.userData
        return role === 100
    }

    isReseller = () => {
        const { isReseller, isClientReseller } = this.userData
        return isClientReseller
            && (isReseller || this.isExploriAdmin())
    }

    isExploriClient = () => {
        const clientId = R.pathOr(false, ['clientId'], this.tokenData)
        return clientId === 1
    }

    isExploriSuper = () => {
        const { clientId } = this.tokenData
        const { role } = this.userData
        return clientId === 1 && role === 100
    }

    hasProSurveysEnabled = () => {
        const { flags } = this.userData

        return flags.isProSurveysEnabled
    }

    hasRapidSurveysEnabled = () => {
        const { flags } = this.userData

        return flags.isRapidSurveysEnabled
    }

    canAccessMaxbiDashboard = () => {
        let canAccess = false
        if (this.getMaxbiStatus().maxbi) {
            const clientDashEnabled = R.path(['flags', 'isNewDashboardEnabled'], this.userData)
            const userDashEnabled = R.path(['flags', 'isUserDashboardsEnabled'], this.userData)

            if (this.userData.role === 100
                || (this.userData.role === 110 && clientDashEnabled)
                || (this.userData.role === 150 && clientDashEnabled && userDashEnabled)
            ) {
                canAccess = true
            }
        }
        return canAccess
    }

    useV1Dashboard =() => !R.pathOr(false, ['flags', 'isV4DashboardEnabled'], this.userData)

    setShowUserDropdown = (bool) => {
        this.showUserDropdown = bool
    }

    pollLoggedInStatus = () => {
        const that = this
        const pollinterval = 1830 * 1000 // (35mins);
        setTimeout(() => {
            that.checkLoggedInStatus()
        }, pollinterval)
    }

    copyText = async (txt, identifier) => {
        try {
            await window.navigator.clipboard.writeText(txt)
            this.addNotification(null, `${identifier} copied`, 'success')
        } catch (e) {
            this.addNotification(null, `Error copying ${identifier}`, 'error')
        }
    }

    setLicenceAllowance = async (clientId, productId) => {
        const licenceAllowance = await this.http.get(`/licenceAllowance?clientId=${clientId}&productId=${productId}`)
        this.emailAllowance = {
            limit: R.pathOr(0, ['allocatedLicenceGeEmails'], licenceAllowance),
            send: R.pathOr(0, ['sentLicenceGeEmails'], licenceAllowance),
            left: Math.max(0, R.pathOr(0, ['remainingLicenceGeEmails'], licenceAllowance)),
            clientOnlyEmailServers: R.pathOr(false, ['clientOnlyEmailServers'], licenceAllowance),
            isGeSurveyEmailEnabled: R.pathOr(false, ['isGeSurveyEmailEnabled'], licenceAllowance),
            isGeLimitExempt: Boolean(R.pathOr(false, ['isGeLimitExempt'], licenceAllowance)),
        }
    }

    showEmailOption = (survey) => {
        const { emailAllowance } = this
        const { taxonomy } = survey.metadata
        const { surveyType } = taxonomy

        return Boolean(
            surveyType !== 'GE'
            || !process.env.SHOW_EMAIL_ALLOWANCE
            || R.pathOr(false, ['clientOnlyEmailServers'], emailAllowance)
            || R.pathOr(false, ['isGeSurveyEmailEnabled'], emailAllowance),
        )
    }

    invalidateSession = () => {
        this.hasValidSession = false
    }

    loggedInStatusNew = async () => {
        const response = await fetch('/api/loggedInStatus')
        return response.json()
    }

    loggedInStatusOld = async () => {
        const response = await fetch('/srv/get/loggedInStatus?format=raw')
        const loggedIn = await response.json()
        return {
            loggedIn,
        }
    }

    loggedInStatus = async () => (
        process.env.USE_NEW_LOGIN
            ? this.loggedInStatusNew()
            : this.loggedInStatusOld()
    )

    checkLoggedInStatus = async (pollStatus = true) => {
        try {
            const { loggedIn } = await this.loggedInStatus()

            if (loggedIn === true) {
                this.loggedIn = true
                this.loginRedirect = ''
                this.hasValidSession = true
                if (pollStatus) this.pollLoggedInStatus()
            } else {
                if (loggedIn.redirected) {
                    this.loginRedirect = loggedIn.url.replace(domain, '')
                }
                this.loggedIn = false
            }
        } catch (e) {
            console.error(e)
            this.loggedIn = false
        }
    }

    /** Get user level */
    getUserRole = (role = undefined) => {
        const { tokenData } = this
        // Role 100 SUPER_USER . 1
        // Role 110 MASTER_USER . 2
        // Role 120 DIVISIONAL_USER . 3
        // Role 130 PORTFOLIO_USER . 4
        // Role 140 PRODUCT_USER . 5
        // Role 150 DIRECTOR_USER . 6
        // Role 160 SURVEY_USER . 7 - Deprecated
        // Role 170 REPORT_USER . 8
        let userRole = ''
        if ((tokenData && tokenData.roles) || role) {
            const roles = role || tokenData.roles
            if (roles.includes(100)) {
                userRole = 'SUPER'
            } else if (roles.includes(110)) {
                userRole = 'MASTER'
            } else if (roles.includes(120)) {
                userRole = 'DIVISION'
            } else if (roles.includes(130)) {
                userRole = 'PORTFOLIO'
            } else if (roles.includes(140)) {
                userRole = 'PRODUCT'
            } else if (roles.includes(150)) {
                userRole = 'DIRECTOR'
            } else if (roles.includes(170)) {
                userRole = 'REPORT'
            }
        }
        return userRole
    }

    setLang = (langcode) => {
        try {
            this.langcode = langcode
        } catch (e) {
            console.error(e)
        }
    }

    updateBreadcrump = (target, value) => {
        const obj = this.breadcrumps.find((crump) => crump.name === target)

        if (obj) {
            obj.title = value
        }
    }

    changeLanguage = (locale) => {
        this.lang = locale
    }

    toggleShowIds = () => {
        this.showIds = !this.showIds
    }

    getDataviewerLink = ({
        schema,
        table,
        column,
        operator,
        value,
    }) => {
        const queryParams = process.env.USE_NEW_DATAVIEWER
            ? `schema=${schema}&tablename=${table}&filter=${column}|${operator}|${value}`
            : `schema=${schema}&tablename=${table}&f1=${column}&op1=${operator}&val1=${value}&viewdata=true`

        return `/intranet/dataviewer?${queryParams}`
    }

    getHashParams = () => {
        const that = this
        const hashes = window.location.hash.substr(1).split('/')
        hashes.forEach((queryParam, index) => {
            if (queryParam === 'surveyId') {
                that.queryParams[queryParam] = hashes[(index + 1)]
            }
        })
    }

    setSurvey = (token) => {
        const store = this
        store.token = token
        store.survey = new Survey(store)
        const { survey } = store
        survey.initSurvey()
            .then(() => {
                if (store.surveyId) {
                    survey.populate(store.surveyId, store, () => {
                        if (store.queryParams.questionId) {
                            survey.editable_question.populate(store.queryParams.questionId, survey, (e) => {
                                if (e) {
                                    console.error(e)
                                    store.mode = 'failed'
                                }
                            })
                        } else {
                            survey.editable_question.setLangs(survey, {})
                        }
                    })
                } else if (store.queryParams.questionId) {
                    survey.editable_question.populate(store.queryParams.questionId, survey, (e) => {
                        if (e) {
                            console.error(e)
                            store.mode = 'failed'
                        } else {
                            store.mode = 'ready'
                        }
                    })
                } else {
                    survey.survey_languages = store.languages
                    survey.editable_question.setLangs(store.languages, {})
                    store.mode = 'ready'
                }
            }).catch((e) => {
                console.error(e)
            })
    }

    initSurvey(industryCode) {
        // this.survey.reset()
        this.survey = new Survey(this)
        this.survey.industryCode = industryCode
    }

    getStatus = (responses, hasLiveResponse = []) => {
        const { survey } = this
        const { metadata } = survey
        const { taxonomy, status } = metadata
        const { surveyType } = taxonomy
        let statusValue = ''
        let style = ''
        let icon = ''
        this.surveyClosed = survey.closed

        if (surveyType === 'EM') {
            if (status === 'Archived') {
                statusValue = 'status_4'
                style = 'archive'
            } else if (hasLiveResponse.length === 0) {
                statusValue = 'Not Started'
                style = 'error'
                icon = 'fa-regular fa-ban'
            } else {
                statusValue = !hasLiveResponse.includes('dropped') ? 'completed' : 'In progress'
                style = !hasLiveResponse.includes('dropped') ? 'success' : 'warning'
                icon = !hasLiveResponse.includes('dropped') ? 'fa-regular fa-circle-check' : 'fa-regular fa-circle-half-stroke'
            }
        } else {
            switch (status) {
                case 'Created':
                    statusValue = responses < 1 ? 'status_2' : 'status_1'
                    style = `${responses < 1 ? 'warning' : 'success'}`
                    break
                case 'Closed':
                    statusValue = 'status_3'
                    style = 'error'
                    break
                case 'Archived':
                    statusValue = 'status_4'
                    style = 'archive'
                    break
                default:
                    break
            }
        }

        return {
            status,
            style,
            label: i18n.t(statusValue),
            icon,
        }
    }

    addNotification = (event, msg, level) => {
        if (event) {
            event.preventDefault()
        }
        this._notificationSystem.addNotification({
            message: msg,
            level,
        })
    }

    addWelcome() {
        this.pages.push(observable.map({
            label: 'Welcome Text',
            type: 'welcome',
            questions: [{
                type: 'welcome',
            }],
        }))
        this.max_page += 1
    }

    addPage(type, label, index) {
        const page = new Page(type, label, (this.pages.length + 1))
        if (!index) {
            this.pages.push(page)
        } else {
            this.pages.splice(index + 1, 0, page)
        }
        this.max_page += 1
    }

    gotoExternal = (target, e) => {
        window.open(target, '_blank')
        if (e) {
            e.stopPropagation()
        }
    }

    goTo = (target, fullUrl, surveyId) => {
        const store = this
        const { survey } = store
        let url = `/survey/${surveyId || survey.id}`
        switch (target) {
            case 'setup':
                url += '/setup'
                break
            case 'report':
                url += '/report'
                break
            case 'preview':
                url += '/preview'
                break
            case 'email':
                url += '/distribute'
                break
            case 'user':
                url += '/user'
                break
            case 'full':
                url = fullUrl
        }
        window.location.href = url
    }

    allowLoginChoose = () => (
        R.path(['isMultiAccount'], this.userData)
            && (
                R.path(['isAdmin'], this.userData)
                || R.path(['isReseller'], this.userData)
            )
    )

    hasMandatoryQuestions = () => {
        const { survey, mandatoryQuestions = [] } = this

        const pageQuestions = survey.pages.reduce((pq, page) => (
            page.questions
                ? pq.concat(page.questions.map(({ questionId }) => questionId.toUpperCase()))
                : pq
        ), [])

        return mandatoryQuestions.filter(({ questionId }) => (
            pageQuestions.indexOf(questionId.toUpperCase()) === -1
        )).length
    }

    initNew = async () => {
        this.http = new Http(window.location.hostname, this)
        await this.checkLoggedInStatus()
        if (this.loggedIn || this.loginRedirect) {
            try {
                const session = await fetch('/api/session')
                const userData = await session.json()
                this.userData = new UserData(userData)

                const { token } = userData
                const jwtData = JSON.parse(atob(token.split('.')[1]))

                const [localesRes, industriesRes, currenciesRes] = await Promise.allSettled([
                    this.http.get('/locales', token),
                    this.http.get('/client/industry', token),
                    this.http.get('/currencies', token),
                ])

                const locales = localesRes.status === 'fulfilled' ? localesRes.value : []
                const industries = industriesRes.status === 'fulfilled' ? industriesRes.value : []
                const currencies = currenciesRes.status === 'fulfilled' ? currenciesRes.value : []

                this.client.currencies = currencies.map((c) => c.currency)
                this.client.industries = industries
                this.client.industryVENU = this.checkIndustryVENU(industries)

                const [respondentTypes, surveyTypes, productMap] = await Promise.all([
                    this.http.get(`/client/${this.userData.clientId}/respondenttype`, token),
                    this.http.get(`/client/${this.userData.clientId}/surveytype`, token),
                    getProductMap(this.http, this.userData.clientId, false, token),
                ])

                this.client.prodductMap = productMap
                this.client.respondentTypes = respondentTypes
                this.client.surveyTypes = surveyTypes

                if (this.allowLoginChoose()) {
                    const accountResponse = await this.http.get('/user/accounts', token)
                    const { clients, accounts } = accountResponse

                    const roleMap = [[100], [110], [120], [130], [140], [150], [170]].reduce((map, role) => (
                        R.mergeRight(map, {
                            [role]: this.getUserRole(role),
                        })
                    ), {})

                    this.userAccounts = accounts.map((account) => ({
                        userId: account.userId,
                        clientName: R.pathOr('unknown', [account.clientId], clients),
                        clientId: account.clientId,
                        uuid: account.uuid,
                        clientColumn: `${R.pathOr('unknown', [account.clientId], clients)} [${account.clientId}]`,
                        name: `${account.firstName} ${account.lastName}`,
                        role: roleMap[account.role],
                    }))
                }

                this.timeZone = this.userData.timezone
                this.langcode = this.userData.locale
                this.clientLanguages = locales
                this.clientLocales = locales.reduce((l, { langcode }) => (
                    R.mergeLeft(l, {
                        [langcode]: i18n.t(`locale.${langcode}`),
                    })
                ), {})
                this.localeOptions = locales.map(({ langcode }) => (
                    {
                        value: langcode,
                        label: this.clientLocales[langcode],
                    }
                ))
                this.tokenData = jwtData
                this.token = token
                await this.getServiceStatusHeaderMessage()
            } catch (e) {
                console.error(`init error: ${e}`)
                this.userData = {}
                this.timeZone = 'Europe/London'
                this.langocode = 'en_GB'
            }

            this.superUser = R.pathOr(0, ['role'], this.userData) === 100
            this.changeLanguage({ value: 'en_GB', label: 'English (UK)' })
            this.tokenLoaded = true

            this.mixpanel?.identify(this.userData, this.isExploriAdmin())
            this.mixpanel?.trackLogin()
        }
    }

    init = async () => (
        this.initNew()
    )

    isMessageCollapsed = (msgId) => this.getCollapsedMsgs().includes(msgId)

    checkIndustryVENU = (industries) => {
        const hasVENU = industries.some((i) => i.code === 'VENU')
        const hasOnlyVENU = hasVENU && industries.length === 1
        return { hasVENU, hasOnlyVENU }
    }

    getCollapsedMsgs = () => {
        try {
            const collapsedMsgs = sessionStorage.getItem(COLLAPSED_SSM_KEY)
            return collapsedMsgs ? JSON.parse(collapsedMsgs) : []
        } catch (err) {
            console.error('Error getting collapsed messages from session storage:', err)
            return []
        }
    }

    saveCollapse = (msgId) => {
        try {
            const collapsedMsgs = this.getCollapsedMsgs()
            if (!collapsedMsgs.includes(msgId)) {
                collapsedMsgs.push(msgId)
                sessionStorage.setItem(COLLAPSED_SSM_KEY, JSON.stringify(collapsedMsgs))
            }
        } catch (err) {
            console.error('Error saving collapsed messages from session storage:', err)
        }
        this.shouldShow = !this.shouldShow
    }

    getMaxbiStatus = () => {
        const { surveyTypes } = this.client
        const maxbi = !!surveyTypes.includes('EM')
        const nonMaxbi = !!surveyTypes.some(((s) => s !== 'EM'))
        return { maxbi, nonMaxbi }
    }

    getDashboardLink = (scope, id) => {
        const url = '/company/dashboard/'

        switch (scope) {
            case 'division':
                return `${url}?portfolioId=${id}`
            case 'portfolio':
                return `${url}?portfolioId=${id}`
            case 'product':
                return `${url}?productId=${id}`
            default:
                return url
        }
    }

    getDashboard = () => {
        const dashboard = {
            label: 'Dashboard',
            roles: [100, 110, 150],
            icon: 'fa-regular fa-gauge-simple-max',
            url: this.getDashboardLink('company'),
        }

        if (!this.getMaxbiStatus().nonMaxbi) return dashboard

        return dashboard
    }

    removePage(index) {
        this.pages.splice(index, 1)
    }

    setOptions(question, options) {
        question.set('options', options)
    }

    addQuestion(questions, pageIndex) {
        const question = new Question()
        question.page_index = pageIndex
        questions.push(question)
        this.num_questions += 1
    }

    removeQuestion(page, questionId) {
        page.get('questions').splice(questionId, 1)
        this.num_questions -= 1
    }

    initializeHotjar = () => {
        if (!hotjar.initialized()) {
            hotjar.initialize(process.env.HJID, process.env.HJSV)
        }
    }

    hotJarSetup = (path) => {
        // remove this comment once testing is done
        // if (this.isExploriAdmin() || this.isExploriClient()) {
        //     return
        // }

        this.initializeHotjar()
        hotjar.stateChange(path)
        hotjar.identify(this.userData.userId, {
            loginId: this.userData.loginId,
            clientId: this.userData.clientId,
            isExploriReseller: this.userData.isReseller,
            isExploriAdmin: this.isExploriAdmin(),
            role: this.userData.role,
            sessionId: this.userData.sessionId,
        })
    }

    /**
     * @todo fetch logged in users from server
     */
    getLoggedInUsers = () => Math.ceil(Math.random() * 10)

    presentationAccess = () => (
        this.isExploriStaff()
        || R.pathOr(0, ['userData', 'flags', 'pptLevel'], this) > 0
    )

    getServiceStatusHeaderMessage = async () => {
        const result = await this.http.get('/intranet/serviceStatus')
        if (Array.isArray(result)) {
            const ssm = result[0]
            this.updateServiceStatusDetails(ssm) // old endpoint
        } else {
            this.updateServiceStatusDetails(result)
        }
    }

    updateServiceStatusDetails = (statusObj) => {
        this.serviceStatus = {
            id: R.pathOr(null, ['id'], statusObj),
            status: R.pathOr('', ['status'], statusObj),
            style: R.pathOr('', ['style'], statusObj),
            collapsible: Boolean(R.pathOr(false, ['collapsible'], statusObj)),
            textColor: R.pathOr(undefined, ['textColor'], statusObj),
            bgColor: R.pathOr(undefined, ['bgColor'], statusObj),
            dismissed: false,
        }
    }

    showNewDashboards = () => {
        const { userData } = this
        return R.pathOr('none', ['dashboardStatus'], userData) === 'v4'
    }

    /** Tags */
    getRecordTags = async (oid, recordId, templateTags = false) => {
        let tags = {}
        try {
            const recordTags = await this.http.get(`/tag/record/${recordId}/oid/${oid}`)
            if (templateTags) return recordTags // easier to manipulate as such
            tags = recordTags.reduce((tags, tag) => {
                const {
                    questionType,
                    str,
                    numeric,
                    optionId,
                    tagId,
                } = tag
                let tagValue
                if (['I', 'TX'].includes(questionType)) {
                    tagValue = R.or(str, numeric)
                } else if (questionType === 'SB') {
                    tagValue = optionId
                } else if (questionType === 'CH') {
                    tagValue = R.pathOr([], [tagId], tags)
                    tagValue.push(optionId)
                }
                return Object.assign(tags, {
                    [tagId]: tagValue,
                })
            }, {})
        } catch (e) {
            console.error(e)
        }

        return tags
    }

    getAvailableTagsSurvey = async (params) => {
        const {
            industry,
            divisionId,
            portfolioId,
            productType,
            surveyType,
            respondentType,
        } = params
        let tags = []

        try {
            tags = await this.http.get(`/tag/7/${industry}/${divisionId}/${portfolioId}/${productType}/${surveyType}/${respondentType}`)
        } catch (e) {
            console.error(e)
        }

        return tags
    }

    getAvailableTagsProduct = async (params) => {
        const {
            industry,
            divisionId,
            portfolioId,
            productType,
        } = params
        let tags = []

        try {
            tags = await this.http.get(`/tag/6/${industry}/${divisionId}/${portfolioId}/${productType}`)
        } catch (e) {
            console.error(e)
        }

        return tags
    }

    getAvailableTagsPortfolio = async (params) => {
        const { industry, divisionId } = params
        let tags = []

        try {
            tags = await this.http.get(`/tag/5/${industry}/${divisionId}`)
        } catch (e) {
            console.error(e)
        }

        return tags
    }

    getAvailableTagsDivision= async (params) => {
        const { industry } = params
        let tags = []

        try {
            tags = await this.http.get(`/tag/4/${industry}`)
        } catch (e) {
            console.error(e)
        }

        return tags
    }

    getAvailableTagsClient = async () => {
        let tags = []

        try {
            tags = await this.http.get('/tag/3')
        } catch (e) {
            console.error(e)
        }

        return tags
    }

    getAvailableTags = async (params) => {
        const { oid } = params
        let tags = []

        switch (parseInt(oid, 10)) {
            case 7:
                tags = await this.getAvailableTagsSurvey(params)
                break
            case 6:
                tags = await this.getAvailableTagsProduct(params)
                break
            case 5:
                tags = await this.getAvailableTagsPortfolio(params)
                break
            case 4:
                tags = await this.getAvailableTagsDivision(params)
                break
            case 3:
                tags = await this.getAvailableTagsClient()
                break
            default:
                console.error(`Invalid oid ${oid} for getAvailableTags`)
        }

        return tags.map((tag) => {
            let options

            switch (tag.questionType) {
                case 'SB':
                case 'CH':
                    options = R.pathOr([], ['options'], tag).map(({ optionId, optionConfig }) => ({
                        value: optionId,
                        label: R.pathOr('', ['langs', 'en_GB'], optionConfig),
                    }))
                    break
                default:
            }
            return {
                tagId: tag.tagId,
                questionType: tag.questionType,
                label: tag.description,
                isMandatory: tag.isMandatory,
                options,
            }
        })
    }

    saveTags = async (recordId, oid, availableTags, recordTags) => {
        const tagTypes = availableTags.reduce((types, { tagId, questionType }) => (
            Object.assign(types, {
                [tagId]: questionType,
            })
        ), {})

        const validTagIds = availableTags.reduce((ids, { tagId }) => (
            ids.add(Number(tagId))
        ), new Set())

        const tags = R.toPairs(recordTags).reduce((tags, [tagId, value]) => {
            if (R.isNil(value) || R.isEmpty(value) || !validTagIds.has(Number(tagId))) return tags

            const tagType = tagTypes[tagId]
            let newRecordTags = []

            switch (tagType) {
                case 'CH':
                    newRecordTags = tags.concat(value.slice().map((optionId) => ({
                        tagId,
                        optionId,
                    })))
                    break
                case 'SB':
                    newRecordTags = tags.concat({
                        tagId,
                        optionId: value,
                    })
                    break
                case 'I':
                    newRecordTags = tags.concat({
                        tagId,
                        numeric: value,
                    })
                    break
                case 'TX':
                    newRecordTags = tags.concat({
                        tagId,
                        str: value,
                    })
                    break
                default:
            }

            return newRecordTags
        }, [])
        await this.http.post(`/tag/record/${recordId}/oid/${oid}`, JSON.stringify(tags))
    }

    getAvailableTagsTemplate = async (params) => {
        const {
            industry, divisionId, portfolioId, productType, surveyType, respondentType,
        } = params
        try {
            return await this.http.get(
                `/tag/0/${industry}/${divisionId}/${portfolioId}/${productType}/${surveyType}/${respondentType}`,
            )
        } catch (e) {
            console.error(e)
        }
    }

    saveTemplateTags = async (recordId, body) => {
        try {
            await this.http.post(`/tag/record/${recordId}/oid/7`, JSON.stringify(body))
            this.addNotification(null, 'Template tags updated', 'success')
        } catch (error) {
            this.addNotification(null, 'Template tags failed to update', 'error')
        }
    }

    /** end Tags */

    toggleIsEditClientOpen = (val) => {
        if (val) this.isEditClientOpen = val
        else this.isEditClientOpen = !this.isEditClientOpen
    }

    setPageLabel = (page, value) => {
        const { survey } = this

        if (survey.closed || page.title === value) return
        page.title = value
        page.update(this, survey)
    }

    publishTemplateSurvey = async (publish = true) => {
        const body = { publish }
        try {
            await this.http.post(`/template/${this.survey.id}/publish`, JSON.stringify(body))
            this.survey.metadata.isTemplatePublished = publish
            this.addNotification(null, `Template successfully ${publish ? 'published' : 'unpublished'}`, 'success')
        } catch (error) {
            console.error('Error publishing template ', error)
            this.addNotification(null, `Template could not be ${publish ? 'published' : 'unpublished'}`, 'error')
        }
    }
}

export default AppState
